import { isProdEnv } from '@rover/cloudflare/src/utilities/environment';

import { isReactNative } from '../Env/react';

import { STATSIG_API_KEYS } from './config';
import { LogLevel, RoverStatsigUser, StatsigOptions, StatsigUser } from './types';

export interface StatsigConfig {
  apiKey: string;
  clientOptions: StatsigOptions;
}

export const getStatsigConfig = (): StatsigConfig => {
  const isProd = isProdEnv();
  const isRxN = isReactNative();

  let apiKeyEnv: string;
  if (isRxN) {
    apiKeyEnv = isProd ? 'rxn_production' : 'rxn_dev';
  } else {
    apiKeyEnv = isProd ? 'react_production' : 'react_dev';
  }

  const apiKey = STATSIG_API_KEYS[apiKeyEnv];

  const clientOptions: StatsigOptions = {
    environment: { tier: isProd ? 'production' : 'development' },
    logLevel: isProd ? LogLevel.None : LogLevel.Debug,
  };

  return { apiKey, clientOptions };
};

export const userNeedsUpdate = (
  currentUser: StatsigUser | undefined,
  newUser: RoverStatsigUser
): boolean => {
  if (!currentUser) {
    return true;
  }

  if ((currentUser.appVersion ?? null) !== (newUser.appVersionName ?? null)) return true;
  if (currentUser.country !== newUser.country) return true;
  if (currentUser.email !== newUser.email) return true;
  if (currentUser.custom?.source !== newUser.source) return true;
  if (currentUser.userID !== newUser.userID) return true;
  if (currentUser.customIDs?.rover_cid !== newUser.vendorID) return true;

  return false;
};

export const createUserPayload = (
  newUser?: RoverStatsigUser,
  currentUser?: StatsigUser
): Partial<StatsigUser> => {
  const payload: Partial<StatsigUser> = {};
  payload.appVersion = newUser?.appVersionName ?? currentUser?.appVersion;
  payload.country = newUser?.country ?? currentUser?.country;
  payload.email = newUser?.email;
  payload.userID = newUser?.userID;
  payload.custom = {
    ...((newUser?.custom ?? currentUser?.custom) || {}),
    source: newUser?.source ?? currentUser?.custom?.source,
  };
  payload.customIDs = { rover_cid: newUser?.vendorID ?? currentUser?.customIDs?.rover_cid };

  return payload;
};
